/** Small helpers shared by the importers (workbook reading, preview samples). */
import * as XLSX from 'xlsx';

export const SAMPLE_LIMIT = 5;

export const readWorkbook = async (file) => {
    const data = await file.arrayBuffer();
    return XLSX.read(new Uint8Array(data), { type: 'array' });
};

/** First sheet as objects keyed by header (default) or as arrays with `{ header: 1 }`. */
export const firstSheetRows = (workbook, options) => {
    const sheet = workbook.Sheets[workbook.SheetNames[0]];
    return sheet ? XLSX.utils.sheet_to_json(sheet, options) : [];
};

/** Up to 5 preview rows, mapped for display. */
export const samplesOf = (items, mapFn) => (items || []).slice(0, SAMPLE_LIMIT).map(mapFn);

export const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));
export const BATCH_SIZE = 450;
export const BATCH_DELAY_MS = 800;
